import React from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Button,
    Box,
    CircularProgress,
} from '@mui/material';
import { ReactComponent as VideomailWarningIcon } from '../../assets/images/VideomailWarning.svg';

const dialogContentTextSx = {
    fontWeight: 700,
    color: '#000000',
};

const deleteButtonSx = {
    backgroundColor: '#DF352C',
    borderRadius: '500px',
    color: '#FFF',
    boxShadow: 'none',
    fontWeight: 600,
    width: '90px',
    '&:hover': {
        backgroundColor: '#F18A82',
        boxShadow: 'none',
    },
    '&:focus': {
        boxShadow: 'none',
        outline: 'none',
    },
};

const cancelButtonSx = {
    fontWeight: 600,
    color: '#111',
    marginRight: '13px',
    '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    '&:focus': {
        outline: 'none',
    },
};

interface VideomailDialogProps {
    open: boolean;
    onClose: () => void;
    onDeleted: () => void;
    loading: boolean;
}

const VideomailDialog: React.FC<VideomailDialogProps> = ({ open, onClose, onDeleted, loading }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        maxWidth: 480,
                        padding: '22px',
                        borderRadius: '12px',
                        background: '#FFF',
                        outline: 'none',
                    },
                },
            }}
        >
            <DialogContent>
                <Box display="flex" alignItems="flex-end" justifyContent="center" mb={2}>
                    <VideomailWarningIcon
                        style={{
                            width: '28px',
                            height: '28px',
                            marginRight: 12,
                            marginTop: '-15px',
                        }}
                    />
                    <DialogContentText sx={dialogContentTextSx}>
                        Delete this videomail forever?
                    </DialogContentText>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} sx={cancelButtonSx}>
                    Cancel
                </Button>
                <Button
                    onClick={onDeleted}
                    variant="contained"
                    sx={deleteButtonSx}
                    disabled={loading}
                >
                    {loading ? <CircularProgress size={24} color="inherit" /> : 'Delete'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default VideomailDialog;
